import {
  Box,
  Button,
  InputLabel,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../../context/API_Client";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import CropImage from "./cropImage";
import FileResizer from "react-image-file-resizer";
import CustomButton from "../../reusableComponents/CustomButton";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import { colorBrandObject } from "../../../constants/brandings";
import UploadIcon from "../../../assets/svg/upload_icon.svg";
import { iconDefaultColor } from "../../reusableComponents/constants";

const modalStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const contentStyle = {
  backgroundColor: "#fff",
  padding: "20px",
  borderRadius: "8px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  alignItems: "flex-start",
  textAlign: "left",
  height: "268px",
  width: "416px",
};

function UploadLogo({
  open,
  onClose,
  responseData,
  setLogoUrl,
  versionBI,
  setversionBI,
}) {
  const { updateLogo, setMerchantLogo } = useAuth();
  const [selectedImage, setSelectedImage] = useState("");
  const [croppedImage, setCroppedImage] = useState("");

  const [openCrop, setOpenCrop] = useState(false);

  const handleOpenCrop = () => {
    setOpenCrop(true);
  };

  const handleCloseCrop = () => {
    setOpenCrop(false);
  };

  const callback = (newFileUri) => {
    setSelectedImage(newFileUri);
  };

  const resizeImage = (imageFile) => {
    try {
      FileResizer.imageFileResizer(imageFile, 250, 375, "PNG", 75, 0, callback);
    } catch (err) { }
  };

  const handleImageResize = (event) => resizeImage(event.target.files[0]);

  const handleImageUpload = (event) => {
    const file = event.target.files[0]; // Get the first selected file

    if (file.name.match(/\.(jpg|jpeg|png|svg)$/i)) {
      const fileSizeInBytes = file.size;
      const fileSizeInKilobytes = fileSizeInBytes / 1024;
      if (fileSizeInKilobytes <= 1024) {
        if (file) {
          const reader = new FileReader();

          reader.readAsDataURL(file);

          reader.onload = () => {
            resizeImage(file);
            handleOpenCrop();
          };
        }
      } else {
        customToast("error", "high", "File Size is too large");
      }
    } else {
      customToast("error", "high", "Invalid File Format");
    }
  };

  const handleDrop = (event) => {
    if (event) {
      event.preventDefault()
    }
    const droppedFile = event.dataTransfer.files[0];

    if (droppedFile.name.match(/\.(jpg|jpeg|png|svg)$/i)) {
      const fileSizeInBytes = droppedFile.size;
      const fileSizeInKilobytes = fileSizeInBytes / 1024;
      if (fileSizeInKilobytes <= 1024) {
        if (droppedFile) {
          const reader = new FileReader();

          reader.readAsDataURL(droppedFile);

          reader.onload = () => {
            resizeImage(droppedFile);
            handleOpenCrop();
          };
        }
      } else {
        customToast("error", "high", "File Size is too large");
      }
    } else {
      customToast("error", "high", "Invalid File Format");
    }
  };
  const handleDragOver = (event) => {
    if (event) {
      event.preventDefault()
    }
  };

  const handleCancel = () => {
    setSelectedImage("");
    onClose();
  };

  const handleChange = () => {
    setSelectedImage("");
  };

  function dataURItoBlob(dataURI) {
    var byteString = atob(dataURI.split(",")[1]);
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);

    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const extension = mimeString.split("/")[1];

    var blob = new Blob([ab], { type: mimeString });
    const file = new File([blob], `filename.${extension}`, {
      type: mimeString,
    });
    return file;
  }

  const handleUpload = () => {
    const originalImage = dataURItoBlob(selectedImage);
    const formData = new FormData();
    formData.append("logo", originalImage);
    updateLogo(
      formData,
      function (data) {
        setLogoUrl("");
        setSelectedImage("");
        setversionBI(data?.version);
        onClose();
      },
      function (error) {
        customToast("error", "high", error);
      }
    );
  };

  return (
    <div
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      accept=".png, .jpg, .jpeg, .svg"
    >
      <div>
        <Modal
          open={open}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          style={modalStyle}
        >
          <Box sx={contentStyle}>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "end",
                marginTop: "10px",
              }}
            >
              <img
                src="/assets/close-modal-cross.svg"
                style={{ height: "20px", width: "20px" }}
                onClick={handleCancel}
              />
            </div>

            <CropImage
              openCrop={openCrop}
              onClose={onClose}
              onCloseCrop={handleCloseCrop}
              data={selectedImage}
              setSelectedImage={setSelectedImage}
            />

            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                marginBottom: selectedImage ? "6px" : "30px",
              }}
            >
              {selectedImage ? (
                <img
                  src={selectedImage}
                  alt="Selected"
                  style={{
                    height: "75px",
                    width: "75px",
                    borderRadius: "75%",
                    borderRadius: "50%",
                    border: "3px  solid #E1E1E1",
                  }}
                />
              ) : (

                <>
                  <div style={{ stroke: iconDefaultColor }}>
                    <UploadIcon stroke={`${colorBrandObject?.primaryButtonColor}`} fill={`${colorBrandObject?.primaryButtonColor}`} />
                  </div>
                  {/* <img
                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSxdwG5WBcX_uLxX1_EkyDlVQI5WyuFzI1ePA&usqp=CAU"
                    alt="check"
                    style={{ height: "75px", width: "75px" }}
                  /> */}
                </>
              )}
            </div>

            {selectedImage ? (
              <>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Typography style={{ fontSize: "17px" }} variant="h7">
                    Success !!
                  </Typography>
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    variant="body1"
                    style={{
                      color: "var(--text-medium, rgba(1, 1, 2, 0.60))",
                      fontSize: "14px",
                      alignItems: "center",
                    }}
                  >
                    Logo has been uploaded successfully
                  </Typography>
                </div>
              </>
            ) : (
              <>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Typography style={{ fontSize: "17px" }} variant="h7">
                    Drag and drop logo or{" "}
                  </Typography>
                  <Typography
                    onClick
                    variant="h7"
                    style={{ fontSize: "17px", color: "blue" }}
                  >
                    <span style={{ paddingLeft: "4px" }}>
                      <label htmlFor="fileInput" style={{ color: colorBrandObject.primaryButtonColor }}>Browse from files</label>
                      <input
                        id="fileInput"
                        type="file"
                        accept=".png, .jpg, .jpeg, .svg"
                        style={{ display: "none" }} // Hide the input element
                        onChange={handleImageUpload}
                      />
                    </span>
                  </Typography>
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="body1"
                    style={{
                      color: "var(--text-medium, rgba(1, 1, 2, 0.60))",
                      fontSize: "14px",
                      alignItems: "center",
                    }}
                  >
                    Supported formates: JPEG, PNG, SVG
                  </Typography>
                  <Typography
                    variant="body1"
                    style={{
                      color: "var(--text-medium, rgba(1, 1, 2, 0.60))",
                      fontSize: "14px",
                      alignItems: "center",
                    }}
                  >
                    Max File size : 1MB
                  </Typography>
                </div>
              </>
            )}
            {selectedImage && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  width: "100%",
                  marginTop: "28px",
                }}
              >
                <div style={{ paddingRight: "20px" }}>
                  <CustomButton
                    text={"Change Logo"}
                    type={"secondary"}
                    size={"sm"}
                    onClick={handleChange}
                  />
                </div>
                <CustomButton
                  text={"Save"}
                  type={"secondary"}
                  size={"sm"}
                  variant={"contained"}
                  onClick={handleUpload}
                />
              </div>
            )}
          </Box>
        </Modal>
      </div>
    </div>
  );
}

export default UploadLogo;
